<template>
  <div class="relative">
    <HeadlessComboboxInput
      ref="inputRef"
      class="flex items-center h-12 w-full pl-[3.25rem] pr-4 gap-4 rounded border border-bgr-300 text-base font-semibold truncate placeholder:font-semibold placeholder:text-txt-weak transition hover:bg-bgr-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover focus:border-thm-hover"
      :display-value="
        (option: unknown) => (option as SuggestionOption | null)?.label || ''
      "
      :placeholder="$t(`${trPrefix}placeholders.where`)"
      autocomplete="off"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="handleInput"
      @click="handleClick"
    />

    <div
      class="pointer-events-none absolute top-0 bottom-0 ml-4 flex items-center"
    >
      <WebccIcon name="site/search" class="h-5 w-5" />
    </div>

    <div
      v-if="model"
      role="button"
      class="absolute right-4 top-[0.9rem] cursor-pointer opacity-20 hover:opacity-60"
      @click.stop="handleClearWithFocus"
    >
      <WebccIcon name="site/x" class="h-5 w-5 fill-current text-txt" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ComboboxInput } from '@headlessui/vue'
import type { SuggestionOption } from '~/composables/useDestinationSearch'

const trPrefix = 'www.components.elements.SearchBox.'

const {
  model,
  handleFocus,
  handleBlur,
  handleInput,
  handleClick,
  handleClearWithFocus,
} = injectDestinationSearch()

const inputRef = shallowRef<InstanceType<typeof ComboboxInput>>()

defineExpose({
  inputRef,
})
</script>
